import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../user/user.types';

type Props = {
  accessPremium: UserContextType['accessPremium'];
  source: string;
  sendAnalytics: Function;
} & WithRestrictedModalProps;

const RawPrintActionButton: FC<Props> = ({
  accessPremium,
  sendAnalytics,
  source,
  openRestrictedModal,
}) => {
  const printLawyerPage = () => {
    sendAnalytics();
    window.print();
  };

  return (
    <button
      className="button hide_on--mobile"
      onClick={
        accessPremium
          ? printLawyerPage
          : () => openRestrictedModal(`${source}_print`)
      }
      type="button"
    >
      <i className="material-icons icons__print" />
      <span>
        {' '}
        <FormattedMessage id="components/sub-header/actions/PrintActionButton.tsx/1" />
      </span>
    </button>
  );
};

export const PrintActionButton = withRestrictedModal(RawPrintActionButton);
